<template>
  <div class="content__column content__column--small" v-if="attr">
    <h1 class="content__title">Editar Atributo</h1>
    <form class="form" @submit.prevent="saveAttribute">
      <div class="fom__fieldset">
        
        <div class="form__container">
          <label for="name_es" class="form__label form__label--required">Nombre del atributo (Español)</label>
          <input type="text" class="form__input" name="name_es" id="name_es" v-model="attr.name_es" v-validate="validation.name_es">
          <span v-show="errors.has('name_es')" class="form__alert" v-text="errors.first('name_es')"></span>
        </div>

        <div class="form__container">
          <label for="name_en" class="form__label form__label--required">Nombre del atributo (Inglés)</label>
          <input type="text" class="form__input" name="name_en" id="name_en" v-model="attr.name_en" v-validate="validation.name_en">
          <span v-show="errors.has('name_en')" class="form__alert" v-text="errors.first('name_en')"></span>
        </div>

        <div class="form__container">
          <label for="code_es" class="form__label">Código del atributo (Español)</label>
          <input type="text" class="form__input" name="code_es" id="code_es" v-model="attr.code_es" v-validate="validation.code_es">
          <span v-show="errors.has('code_es')" class="form__alert" v-text="errors.first('code_es')"></span>
        </div>

        <div class="form__container">
          <label for="code_en" class="form__label">Código del atributo (Inglés)</label>
          <input type="text" class="form__input" name="code_en" id="code_en" v-model="attr.code_en" v-validate="validation.code_en">
          <span v-show="errors.has('code_en')" class="form__alert" v-text="errors.first('code_en')"></span>
        </div>

        <div class="form__container">
          <label class="form__label form__label--required" for="type_id">Tipo de Atributo</label>
          <div class="form__select-container">
            <select name="type_id" id="type_id" class="form__select" v-validate="validation.type_id" v-model="attr.type_id">
              <option hidden :value="null">Seleccione un tipo</option>
              <option v-for="(type, index) in types" :key="index" :value="type.id" v-text="type.name"></option>
            </select>
          </div>
          <span v-show="errors.has('type_id')" class="form__alert" v-text="errors.first('type_id')"></span>
        </div>
        <div class="form__container">
          <div class="form__image">
            <label class="form__label" for="icon">Icono del atributo</label>
            <img :src="icon" alt="Attribute Icon" class="form__thumb">
            <button class="btn btn__action btn--small" @click.prevent="showMedia = true">Cargar Icono</button>
            <button v-if="attr.icon" class="btn btn__transparent btn--small" @click.prevent="icon = null">Quitar Icono</button>
          </div>
        </div>
      </div>
      <input type="submit" class="btn btn__action btn--regular" value="Guardar">
      <button @click.prevent="$emit('new')" class="btn btn__transparent btn--regular">Agregar Nuevo atributo</button>
    </form>
    <media-popup @close="showMedia = false" v-if="showMedia" field="icon"></media-popup>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import mediaPopup from '@/components/media/popup'
import {config} from '@/core/config/base'
import Mixins from './mixins'
export default {
  props: {
    attr: {
      type: Object,
      required: false,
      default: function () {
        return {
          id: null,
          name_es: null,
          name_en: null,
          code_es: null,
          code_en: null,
          type_id: null,
          icon: null
        }
      }
    }
  },
  mixins: [
    httpService,
    Mixins
  ],
  components: {
    mediaPopup
  },
  data: function () {
    return {
      newImage: false,
      showMedia: false,
      validation: {
        name_es: 'required|max:50',
        name_en: 'required|max:50',
        code_es: 'max:5',
        code_en: 'max:5',
        type_id: 'min_value:1|max:11'
      }
    }
  },
  created: function () {
    this.getTypes()
  },
  mounted: function () {
    this.$on('icon', media => {
      this.icon = media.image
    })
  },
  methods: {
    saveAttribute: function () {
      this.$validator.validateAll()
        .then(
          result => {
            if (result) {
              let httpRequest = {
                params: '',
                module: 'attributes',
                element: this.attr
              }
              let action
              if (this.attr.id) {
                action = this.put(this.attr.id, httpRequest)
              } else {
                action = this.post(httpRequest)
              }
              action.then(
                response => {
                  if (!this.attr.id) {
                    this.attr.id = response.data.current_id
                  }
                  this.$store.commit('elementChanged', {
                    module: 'attributeEdit',
                    time: Math.round((new Date()).getTime() / 1000)
                  })
                  this.$store.commit('notificate', {
                    title: 'ATRIBUTO GUARDADO',
                    text: 'El atributo ha sido guardado correctamente',
                    type: 'success'
                  })
                }
              ).catch(
                () => {
                  this.$store.commit('notificate', {
                    title: 'ATRIBUTO NO GUARDADO',
                    text: 'El atributo no ha sido guardado, por favor, intente más tarde',
                    type: 'error'
                  })
                }
              )
            }
          }
        )
    }
  },
  computed: {
    icon: {
      get: function () {
        if (this.attr.icon) {
          let image = undefined
          if (this.newImage) {
            image = this.attr.icon
          } else {
            image = JSON.parse(this.attr.icon)
          }
          return config.statics.url + image.sizes.small
        } else {
         return config.statics.dummy
        }
      }, set: function (value) {
        this.newImage = true
        this.attr.icon = value
      }
    }
  }
}
</script>

<style lang="sass">
  @import "../../assets/sass/components/_forms"
</style>


// WEBPACK FOOTER //
// src/components/attributes/edit.vue